module.exports = __webpack_public_path__ + "static/media/IMG_1727.b1527e28.JPG";